<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="80px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">
                                {{ getRouteName($route) }} {{ types[form.resourcetype] &&
                                types[form.resourcetype].label }}
                            </span>
                            <form-language-switcher/>
                        </div>
                        <el-form-item label="Nazwa robocza"
                                      :error="errors['working_name']">
                            <el-input v-model="form['working_name']"
                                      placeholder="Nazwa robocza dla administratorów"/>
                        </el-form-item>
                        <base-widget :form.sync="form"
                                     :errors="errors"/>
                        <component :is="widgetComponent"
                                   :form.sync="form"
                                   :errors="errors"/>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {Widget} from '@/api/';
    import BaseWidget from '@/components/widgets/forms/BaseWidget'

    export default {
        data () {
            return {
                loading: false,
                redirectRoute: {name: 'Widgets List'},
                form: {},
                errors: {},
                widgetComponent: null,
                service: Widget,
                types: {}
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            BaseWidget
        },
        methods: {
            fetchData () {
                if (this.$route.params.id) {
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                        this.widgetComponent = this.getWidgetComponent(this.form.resourcetype)
                    })
                } else {
                    this.$set(this.form, 'resourcetype', this.$route.params.type)
                    this.widgetComponent = this.getWidgetComponent(this.form.resourcetype)
                }
                this.service.types().then(response => {
                    this.types = response.data;
                })
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const service = id ? this.service.update(id, this.form) : this.service.save(this.form)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// WidgetForm.vue?6864f48c